import React, { Component } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ToastrAction from '../../home/actions/ToastrAction'
import { isEqual } from 'lodash'
import { ERROR, INFO, SUCCESS, WARNING } from '../../home/constants/ToastrConstants'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import Icon from '@material-ui/core/Icon'

class ToastrPanel extends Component {
	constructor(props) {
		super(props)
	}

	close = (event, reason) => {
		if (reason && reason !== 'clickaway') {
			this.props.reset()
		}
	}

	getIcon = () => {
		switch (this.props.messageType) {
			case ERROR: {
				return 'error'
			}
			case INFO: {
				return 'info'
			}
			case SUCCESS: {
				return 'error'
			}
			case WARNING: {
				return 'error'
			}
			default :
				return 'error'
		}
	}
	getStyle = () => {
		switch (this.props.messageType) {
			case ERROR: {
				return {
					backgroundColor: 'red'
				}
			}
			case INFO: {
				return {
					backgroundColor: 'blue'
				}
			}
			case SUCCESS: {
				return {
					backgroundColor: 'green'
				}
			}
			case WARNING: {
				return {
					backgroundColor: 'orange'
				}
			}
			default : {
				return {
					backgroundColor: 'blue'
				}
			}
		}
	}

	getContent = () => {
		return (
			<SnackbarContent
				style={ this.getStyle() }
				aria-describedby='client-snackbar'
				message={
					<span id='client-snackbar' style={ {
						display: 'flex',
						alignItems: 'center'
					} }>
						<Icon className='material-icons'>{ this.getIcon() }</Icon>
						{ this.props.message }
        			</span>
				}
			/>
		)
	}

	shouldComponentUpdate(nextProps) {
		return (
			!isEqual(this.props.messageType, nextProps.messageType) ||
			!isEqual(this.props.message, nextProps.message) ||
			!isEqual(this.props.open, nextProps.open)
		)
	}

	render() {
		return (
			<Snackbar
				anchorOrigin={ {
					vertical: 'top',
					horizontal: 'right'
				} }
				open={ this.props.open }
				autoHideDuration={ 4000 }
				onClose={ this.close }
				ContentProps={ {
					'aria-describedby': 'message-id'
				} }
			>
				{ this.getContent() }
			</Snackbar>
		)
	}
}

ToastrPanel.propTypes = {
	messageType: PropTypes.string,
	message: PropTypes.string,
	open: PropTypes.bool,
	reset: PropTypes.func
}
ToastrPanel.defaultProps = {
	messageType: '',
	message: '',
	open: false
}
const mapStateToProps = store => {
	return {
		messageType: store.ToastrReducer.messageType,
		message: store.ToastrReducer.message,
		open: store.ToastrReducer.open
	}
}
const mapDispatchToProps = {
	reset: ToastrAction.reset
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ToastrPanel)



// WEBPACK FOOTER //
// ./src/components/toastr/ToastrPanel.js